export const secondsInYear = 31536000;
export const secondsInMonth = 2592000;
export const secondsInDay = 86400;
export const secondsInHour = 3600;

export const NOTIFICATION_DURATION = 6000;

export const userTemplateColumns = ['First Name', 'Last Name', 'Email address (Mandatory)', 'Role'] as const;
export const DESKTOP_MEDIUM = 1440;